<template>
  <div class="view-webhook">
    <page-header
      title="Webhook (API e notificações)"
      subtitle="Configure suas integrações e notificações de vendas com API da Blitzpay"
    />
    <page-container>
      <bp-table-header :total="pagination.count" @refresh="refresh">
        <template v-slot:buttons>
          <bp-input
            v-model="search"
            size="md"
            placeholder="Buscar pela descrição"
            preIcon="fa-light fa-search"
            :delay="300"
            @change="dispatch()"
          />
          <bp-button
            size="md"
            icon="fa-light fa-plus"
            label="Nova configuração"
            @click="add"
          />
        </template>
      </bp-table-header>

      <bp-data-table
        class="my-6"
        :loading="loading"
        :columns="columns"
        :data="integrationList"
      >
        <template v-slot:eventos="{ value }">
          <table-events :events="value" />
        </template>
      </bp-data-table>

      <bp-paginator
        v-model="page"
        :pagination="pagination"
        @change-page="dispatch"
      />

      <responsive-modal
        size="lg"
        v-model="modal"
        :title="integrationToEdit ? 'Editar configuração' : 'Nova configuração'"
      >
        <webhook-modal
          v-model="modal"
          :integrationToEdit="integrationToEdit"
          @refresh="refresh"
          @close="modal = false"
        />
      </responsive-modal>
    </page-container>
  </div>
</template>
<script>
import TableEvents from "@/components/tools/TableEvents.vue";
import WebhookModal from "@/components/tools/modals/Webhook.vue";
import IntegrationMixins from "@/mixins/integration.js";
import get from "lodash/get";
import { mapState } from "vuex";
export default {
  mixins: [IntegrationMixins],
  components: {
    WebhookModal,
    TableEvents
  },
  data() {
    return {
      integration: "generic",
      page: 1,
      columns: [
        {
          name: "Produto",
          field: "product_id",
          transform: this.getProductName
        },
        {
          name: "Descrição",
          field: "description"
        },
        {
          name: "Eventos",
          field: "events",
          transform: v => v.map(e => e.event)
        },
        {
          name: "URL",
          type: "link",
          field: "url",
          size: "0.5fr"
        },
        {
          name: "Status",
          field: "status",
          transform: v => (v ? "Ativo" : "Inativo"),
          class: v => (v ? "active-badge" : "inactive-badge"),
          size: "0.5fr"
        },
        {
          name: "",
          type: "menu",
          options: this.getActions
        }
      ]
    };
  },
  mounted() {
    this.$store.commit("integration/setIntegration", this.integration);
    this.dispatch();
  },
  computed: {
    ...mapState("integration", ["integrationList", "pagination", "typeEvents"]),
    ...mapState("product", ["products"]),
    eventsOptions() {
      let options = [...this.typeEvents];
      options.unshift({ id: "", name: "Todos os eventos" });
      return options;
    }
  },
  methods: {
    getProductName(_, item) {
      return get(
        this.products.find(p => p.id === get(item.events[0], "product_id")),
        "name",
        "-"
      );
    },
    getActions(item) {
      return [
        {
          label: "Editar",
          icon: "fa-light fa-pen",
          click: this.edit
        },
        {
          label: "Enviar teste",
          icon: "fa-light fa-arrow-right",
          click: this.testWebhook
        },
        {
          label: item.status ? "Desativar" : "Ativar",
          color: item.status ? "negative" : "positive",
          icon: "fa-light fa-power-off",
          click: this.changeStatus
        },
        {
          label: "Remover",
          color: "negative",
          icon: "fa-light fa-trash",
          dialog: {
            variant: "negative",
            icon: "fa fa-hexagon-exclamation",
            text: "Deseja mesmo remover esta configuração?",
            secondaryAction: this.submitDelete,
            buttonText: "Cancelar",
            secondaryButtonText: "Confirmar"
          }
        }
      ];
    },

    changeStatus(item) {
      let data = item;
      data.status = !item.status;
      data.product_id = item.events[0].product_id;
      this.$store
        .dispatch("integration/putIntegration", data)
        .then(() => {
          this.$message.success(
            `Configuração ${data.status ? "ativada" : "desativada"}`
          );
        })
        .catch(() => {
          this.$message.error(
            "Não foi possível alterar o status da configuração"
          );
        });
    }
  },
  mounted() {
    this.$store.dispatch("product/get", { limit: 500 });
    this.$store.dispatch("integration/getTypeEvents");
  }
};
</script>
